'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NameCharacterLimitExceededAlert = require('./components/NameCharacterLimitExceededAlert.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_NameCharacterLimitExceededAlert).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/name-character-limit-exceeded-alert/index.js
// module id = 1323
// module chunks = 0